
    <h3 *ngIf="!isEditMode" class="first-heading">Enter</h3>  
    <h5 *ngIf="!isEditMode" class="second-heading">Business Details</h5> 

    <section class="campaign" *ngIf="isEditMode">  
        <div class="campaign__heading">
            <div>
                <h1>Business Details</h1>
            </div>
            <div></div>
        </div>
    </section>

    <!-- Business Form  -->

    <div [class.register-page]="isEditMode">
        <div [class.register-page__main]="isEditMode">
            <div [class.register-page__main__content]="isEditMode">

                <form [formGroup]="businessForm" (ngSubmit)="onSubmit()">

                    <div class="form">
                        <div class="form__main">
            
                            <!-- Business Name Field  -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Business Name" [required]="true"
                                    [control]="businessForm.controls.name"
                                    [patternError]="regexErrors.latinAndSpaces"
                                    formControlName="name"
                                    placeholder="Business Name*">
                                </app-form-field-input>
                            </div>
            
                            <!-- Business Email Field  -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Business Email" [required]="false"
                                    [control]="businessForm.controls.email"
                                    [patternError]="regexErrors.email"
                                    formControlName="email"
                                    placeholder="john@example.com">
                                </app-form-field-input>
                            </div>
            
                            <!-- Province Field  -->
                            <div class="form__main__fields">
                                <app-form-field-select label="Province" [required]="true"
                                    [control]="businessForm.controls.provinceId"
                                    formControlName="provinceId"
                                    [items]="metaData?.province" 
                                    (changed)="selectProvince($event)">
                                </app-form-field-select>
                            </div>
            
                            <!-- Business Phone Field -->
                            <div class="form__main__fields">
                                <app-form-field-input-mask label="Business Phone" [required]="true"
                                    [control]="businessForm.controls.businessPhone"
                                    formControlName="businessPhone"
                                    placeholder="03xx-xxxxxxx"
                                    mask="0000-0000000">
                                </app-form-field-input-mask>
                            </div>
            
                            <!-- City Field  -->
                            <div class="form__main__fields">
                                <app-form-field-select label="City" [required]="true"
                                    [control]="businessForm.controls.cityId"
                                    formControlName="cityId"
                                    [items]="provinceCities">
                                </app-form-field-select>
                            </div>
            
                            <!-- Office Phone  -->
                            <div class="form__main__fields">
                                <app-form-field-input-mask label="Office Phone" [required]="false"
                                    [control]="businessForm.controls.officePhone"
                                    formControlName="officePhone"
                                    mask="000-00000000"
                                    placeholder="0xx-xxxxxxxx">
                                </app-form-field-input-mask>
                            </div>
            
                            <!-- Area Field  -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Area" [required]="true"
                                    [control]="businessForm.controls.area"
                                    formControlName="area"
                                    placeholder="Area">
                                </app-form-field-input>
                            </div>
            
                            <!-- NTN Field  -->
                            <div class="form__main__fields">
                                <app-form-field-input-mask label="NTN" [required]="false"
                                    [control]="businessForm.controls.ntn"
                                    mask="0000000-0" 
                                    placeholder="xxxxxxxx-x"
                                    formControlName="ntn">
                                </app-form-field-input-mask>
                            </div>
            
                            <!-- Sub Area Field  -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Sub Area" [required]="true"
                                    [control]="businessForm.controls.subArea"
                                    formControlName="subArea"
                                    placeholder="Sub Area">
                                </app-form-field-input>
                            </div>
            
                            <!-- Owner Name -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Owner Name" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.ownerName"
                                    formControlName="ownerName" 
                                    placeholder="Owner Name">
                                </app-form-field-input>
                            </div>
            
                            <!-- CNIC -->
                            <div class="form__main__fields">
                                <app-form-field-input-mask label="CNIC" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.cnic"
                                    formControlName="cnic"
                                    placeholder="CNIC"
                                    mask="0000000000000">
                                </app-form-field-input-mask>
                            </div>
            
                            <!-- Landmark -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Landmark" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.landmark"
                                    formControlName="landmark"
                                    placeholder="Land Mark">
                                </app-form-field-input>
                            </div>
            
                            <!-- Industry -->
                            <div class="form__main__fields">
                                <app-form-field-select label="Industry" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.industryId"
                                    formControlName="industryId"
                                    [items]="metaData?.industry">
                                </app-form-field-select>
                            </div>
            
                            <!-- Address -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Address" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.address"
                                    formControlName="address"
                                    placeholder="Address">
                                </app-form-field-input>
                            </div>
            
                            <!-- Comments -->
                            <!-- <div class="form__main__fields">
                                <app-form-field-input label="Comments" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.comments"
                                    formControlName="comments"
                                    placeholder="Comments">
                                </app-form-field-input>
                            </div>
             -->
                            <!-- Business Feedback -->
                            <div class="form__main__fields">
                                <app-form-field-input label="Business Feedback" [required]="true" *ngIf="isLeadView"
                                    [control]="businessForm.controls.customerFeedback" 
                                    formControlName="customerFeedback"
                                    placeholder="Business Feedback">
                                </app-form-field-input>
                            </div>
            
                            <!-- Party Tier -->
                            <div class="form__main__fields">
                                <app-form-field-select label="Party Tier" [required]="false" *ngIf="isLeadView"
                                    [control]="businessForm.controls.partyTierId" 
                                    formControlName="partyTierId"
                                    [items]="metaData?.partyTier">
                                </app-form-field-select>
                            </div>
                        </div>
                    </div>
             <!-- Visit Table -->
                        <div class="campaign__table" *ngIf="isEditMode && isLeadView">
                            <div class="" style="width: 100%; margin-left: 0;">
                                <div class="campain-table">
                                    <table class="table table-boder">
                                        <tbody class="app-body-card">
                                            <tr>
                                                <th style="width: 30%;">
                                                    <h1>Visit Date</h1>
                                                </th>
                                                <th style="width: 70%;">
                                                    <h1>Comments</h1>
                                                </th>
                                               
                                            </tr>
                                            <tr *ngFor="let bv of businessVisit">
                                                <td>
                                                    {{ bv.createdOn | date: 'dd-MMM-yyyy hh:mm:ss a'  }}
                                                </td>
                                                <td>
                                                    {{ bv.comments }}
                                                </td>
                                               
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    <!-- </section> -->
                    <!-- Masking Table -->
                    <!-- <section class="campaign" *ngIf="isEditMode"> -->
                        <div class="campaign__table">
                            <div class="" style="width: 48%; margin-left: 0;">
                                <div class="campain-table">
                                    <table class="table table-boder" *ngIf="partyMasks?.length > 0">
                                        <tbody class="app-body-card">
                                            <tr>
                                                <th style="width: 25%;">
                                                    <h1>Mask Name</h1>
                                                </th>
                                                <th style="width: 25%;">
                                                    <h1>Mask Number</h1>
                                                </th>
                                                <th style="width: 48%;">
                                                    <h1>Description</h1>
                                                </th>
                                                <th style="min-width: 0; width: 2%;"></th>
                                            </tr>
                                            <tr *ngFor="let mask of partyMasks">
                                                <td>
                                                    {{ mask.maskName }}
                                                </td>
                                                <td>
                                                    {{ mask.maskNumber }}
                                                </td>
                                                <td>
                                                    {{ mask.description }}
                                                </td>
                                                <td>
                                                    <div class="user-drop-down" *ngIf="helperService.lstUserRights[enumService?.SCREENS?.Mask].canUpdate">
                                                        <div class="btn-group">
                                                            <a type="button" class="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <div class="dropdown-img"><img src="assets/images/Options.png"></div>
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right">
                                                                <button class="dropdown-item" type="button" (click)="openMaskEditModal(mask)" *ngIf="helperService.lstUserRights[enumService?.SCREENS?.Mask].canUpdate">Edit Mask</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    <!-- </section> -->
            
                    <!-- Buttons  -->
                    <div class="app-center auth-center" *ngIf="!isEditMode">
                        <app-button mat-button [routerLink]="['/auth/login']">Login</app-button>
                        <button class="app-button" type="submit" mat-button>Next <i class="fa fa-angle-right"></i></button>
                    </div>
            
                    <div class="app-center" *ngIf="isEditMode">
                        <button class="app-button mr-1" type="button" (click)="openMaskModal()" *ngIf="helperService.lstUserRights[enumService?.SCREENS?.Mask].canCreate && partyMasks ">Add Mask</button>
                        <button class="app-button mr-1" type="button" (click)="updateProfile()" *ngIf="this.userProfile?.isEditable && helperService.lstUserRights[enumService.SCREENS.UserProfile].canUpdate">Update</button>
                        <button class="app-button" type="button" mat-button matStepperNext>Next <i class="fa fa-angle-right"></i></button>
                    </div>
                </form>

            </div>
        </div>
    </div>

    

    <!-- <code>
        {{ businessForm.value | json }} 
    </code> -->